import { render, staticRenderFns } from "./EditOverlay.vue?vue&type=template&id=b9a62972&scoped=true"
import script from "./EditOverlay.vue?vue&type=script&lang=js"
export * from "./EditOverlay.vue?vue&type=script&lang=js"
import style0 from "./EditOverlay.vue?vue&type=style&index=0&id=b9a62972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a62972",
  null
  
)

export default component.exports